<template>

    <div>
        <div class="modal-overlay"  v-if="showModal"></div>

        <div class="modal" v-if="showModal">
            <div class="confirm-top-logo-container">
                <img src="../assets/images/welcome_back.svg" alt="welcome back">
                <img src="../assets/images/world_wide_web.svg" alt="World Wide Web">
            </div>
            <h3 v-if="success" class="modal-header-success">
                <h3>Successful!</h3>
                <img class="success-icon" src="../assets/checked.svg" alt="Success icon"/>
            </h3>
            <h3 v-if="failed" class="modal-header-fail"><h3>Failed!</h3></h3>
            <div class="response-message">{{response}}</div>
            <div v-if="success">You may proceed to login in {{counter}}</div>
            <router-link class="token-request" v-if="responseType ==='expired_token'" to="/request-new-token">Request New Token</router-link>
            <div class="field redirect">
                <div class="redirect-container">
                    <div>Don't have an account yet? <router-link class="signup-link" to="/signup">Sign Up</router-link></div>
                    <div><router-link class="back-to-login" to="/login">Proceed to Login</router-link></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>


export default {

  name: 'Modal',
  props:{
    responseType:String,
    showModal:Boolean,
    response:String,
    success:Boolean,
    failed:Boolean,

  },
  data() {
    return {
      //   showModal:true,
      counter:5
    };
  },
  beforeUpdate(){
    if(this.success){
      setInterval(()=>{
        if(this.counter > 0)
        {this.counter--;}

        if(this.counter === 0) {
          if(this.$route.path === '/login'){
            this.$router.go();
          }else{
            this.$router.push('/login');
          }
        }
      }, 1000);
    }
  }
};
</script>
<style scoped>
    .field.redirect {
        display: flex;
        margin-top: 45px;
        width: 100%;
    }
    .redirect-container {
        color: white;
        width: 100%;
        font-size: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .redirect-container .back-to-login, .redirect-container .signup-link {
        color:#025fa0
    }
    .back-to-login {
        display: block;
    }
    .redirect-container button {
        width: 40px;
        height: 40px;
        background: var(--white);
        border: none;
        border-radius: 50%;
        margin: 15px;
    }
    .success-icon {
        width: 28px;
        padding: 5px;
        display: flex;
        align-items: center;
    }
    .confirm-top-logo-container {
        /* display: flex; */
        align-items: center;
        display: none; /* Hide Vector image from showing */
    }
    .confirm-top-logo-container img:first-child {
        display: inline-block;
        width: 100px;
    }
    .confirm-top-logo-container img {
        display: inline-block;
        width: 80px;
    }
    .modal-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 98;
        background-color:rgba(0, 0, 0, 0.5);
    }
    .modal {
        position: fixed;
        top:50%;
        left: 50%;
        transform: translate(-50%,-50%);
        z-index: 99;
        width: 100%;
        height: 100%;
        max-width: 450px;
        max-height: 450px;
        background-color: rgb(0 0 0 / 50%);
        color: var(--white);
        border-radius: 16px;
        padding: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .modal .modal-header-fail {
        margin: 50px 10px 10px;
        font-size: 30px;
        color: #c91b0e;
        display: flex;
    }
    .modal .modal-header-success {
        margin: 10px;
        font-size: 30px;
        color: green;
        display: flex;
    }
    .response-message {
        margin-top: 50px;
        text-align: center;
    }
    .token-request {
        background: var(--colorSecondary);
        color: var(--white);
        margin: 35px 50px 50px;
        padding: 15px 35px;
        border-radius: 50px;
    }

    @media only screen and (max-width:767px) {
        .redirect-container {
            display: block;
            text-align: center;
        }
        .redirect-container a {
            display: inline-block;
            margin: 3px 0;
        }
    }
</style>
